import styled, { css } from 'styled-components';
import compareOnIcon from 'images/icons/toggle-on.svg';
import compareOffIcon from 'images/icons/toggle-off.svg';
import layoutFolderOffIcon from 'images/icons/layout-folder-grey.svg';
import layoutFolderOnIcon from 'images/icons/layout-folder-white.svg';
import layoutSpreadOffIcon from 'images/icons/layout-spread-grey.svg';
import layoutSpreadOnIcon from 'images/icons/layout-spread-white.svg';

/* TOOD create a more modular svg component system */
const iconMap = {
  compare: {
    on: compareOnIcon,
    off: compareOffIcon,
  },
  layoutSpread: {
    on: layoutSpreadOnIcon,
    off: layoutSpreadOffIcon,
  },
  layoutFolder: {
    on: layoutFolderOnIcon,
    off: layoutFolderOffIcon,
  },
};

export const StyledIcon = styled.div`
  display: inline-block;
  margin-right: 11px;
  width: ${({ width }) => width || '8px'};
  height: ${({ height }) => height || '8px'};
  background: ${({ icon, toggled }) => toggled ? `url('${iconMap[icon].on}')` : `url('${iconMap[icon].off}')`};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  z-index: 3;

  ${({ type }) => type === 'layout' && css`
    position: absolute;
    width: 12px;
    height: 14px;
    left: 21px;
    top: 7px;

    &:nth-of-type(1) {
      background: ${({ icon, toggled }) => toggled ? `url('${iconMap[icon].off}')` : `url('${iconMap[icon].on}')`};
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
    }

    &:nth-of-type(2) {
      background: ${({ icon, toggled }) => toggled ? `url('${iconMap[icon].on}')` : `url('${iconMap[icon].off}')`};
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
      left: 70px;
    }
  `}
`;

export const ToggleBtnContainer = styled.div`
  position: relative;
  width: 107px;
  height: 28px;
  background: ${({ theme, toggled, type }) => (toggled && type === 'compare' ? theme.colors.palette[3] : '#F3F4F5')};
  border-radius: 30px;
  cursor: pointer;
  float: right;
  transition: all 0.3s ease;
`;

export const ToggleSlide = styled.div`
  width: 60px;
  height: 28px;
  padding: 7px 24px;
  border-radius: 30px;
  background-color: ${({ theme, toggled }) => (toggled ? theme.colors.palette[7] : theme.colors.palette[6])};
  ${({ toggled }) => (toggled ? `margin-left: 47px;` : `margin-right: 47px;`)};
  ${({ type, theme }) => type === 'layout' && `background-color: ${theme.colors.palette[7]}`};
  transition: all 0.3s ease;
`;
